import { PhaseData } from "./NodeDataTyps";

/**
 * A phase's time-out fallback, dropped once it is no longer one of the phase's options —
 * BCM360-364.
 *
 * When time runs out the run takes the fallback's path, and publishing refuses a fallback
 * that is not among the options. Without this, removing or re-pointing the option that was
 * the fallback left the old id behind: the select showed "None", while the stored phase
 * still pointed somewhere else.
 */
export const dropStaleFallback = <T extends Partial<PhaseData>>(data: T): T =>
	data.timeLeftDecisionId &&
	!(data.decisionOptions ?? []).some((option) => option.phaseId === data.timeLeftDecisionId)
		? { ...data, timeLeftDecisionId: undefined }
		: data;
